"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACEPARENT_REGEXP = void 0;
exports.extractTraceparentData = extractTraceparentData;
exports.generateSentryTraceHeader = generateSentryTraceHeader;
exports.propagationContextFromHeaders = propagationContextFromHeaders;

var _baggage = require("./baggage.js");

var _propagationContext = require("./propagationContext.js");

// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const TRACEPARENT_REGEXP = exports.TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
'([0-9a-f]{32})?' + // trace_id
'-?([0-9a-f]{16})?' + // span_id
'-?([01])?' + // sampled
'[ \\t]*$');
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */

function extractTraceparentData(traceparent) {
  if (!traceparent) {
    return undefined;
  }

  const matches = traceparent.match(TRACEPARENT_REGEXP);

  if (!matches) {
    return undefined;
  }

  let parentSampled;

  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2]
  };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */


function propagationContextFromHeaders(sentryTrace, baggage) {
  const traceparentData = extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = (0, _baggage.baggageHeaderToDynamicSamplingContext)(baggage);

  if (!traceparentData || !traceparentData.traceId) {
    return {
      traceId: (0, _propagationContext.generateTraceId)(),
      spanId: (0, _propagationContext.generateSpanId)()
    };
  }

  const traceId = traceparentData.traceId,
        parentSpanId = traceparentData.parentSpanId,
        parentSampled = traceparentData.parentSampled;
  const virtualSpanId = (0, _propagationContext.generateSpanId)();
  return {
    traceId,
    parentSpanId,
    spanId: virtualSpanId,
    sampled: parentSampled,
    dsc: dynamicSamplingContext || {} // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it

  };
}
/**
 * Create sentry-trace header from span context values.
 */


function generateSentryTraceHeader(traceId = (0, _propagationContext.generateTraceId)(), spanId = (0, _propagationContext.generateSpanId)(), sampled) {
  let sampledString = '';

  if (sampled !== undefined) {
    sampledString = sampled ? '-1' : '-0';
  }

  return `${traceId}-${spanId}${sampledString}`;
}